<template>
    <div class="d-flex primary--text align-center">
        <img src="@/assets/logo_demo.svg" height="32px" :alt="title" class="mr-2"/>

        <div>{{title}}</div>
    </div>
</template>

<script>
    export default {
        props: ['src', 'title'],
        name: "navbar-app-logo"
    }
</script>

<style scoped>

</style>
